/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliStudentDto } from '../../models/amoxcalli-student-dto';

export interface ApiStudentsIdGet$Json$Params {
  id: string;
}

export function apiStudentsIdGet$Json(http: HttpClient, rootUrl: string, params: ApiStudentsIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliStudentDto>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliStudentDto>;
    })
  );
}

apiStudentsIdGet$Json.PATH = '/api/students/{id}';
